import { Button, Input } from "antd";
import { IoAlertCircleOutline } from "react-icons/io5";
import { useBankFeeds } from "./bankFeedsAuthProvider";
import { BankFeedsSupportedRutterPlatforms } from "./constants";

type DefaultLoginType = {
  handleCompleteCancel: () => void;
  handleCompleteSubmit: () => void;
  platform: BankFeedsSupportedRutterPlatforms;
};

export const DefaultLogin = (args: DefaultLoginType) => {
  if (args.platform === BankFeedsSupportedRutterPlatforms.INTUIT_BANK_FEEDS) {
    return NoCustomLogin();
  }

  return OtpLogin(args);
};

const NoCustomLogin = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full py-12">
      <IoAlertCircleOutline className="text-[#212430] mb-6" size={64} />
      <h1 className="text-xl sm:text-2xl font-bold text-[#212430] text-center mb-4">
        No login screen has been configured for this organization
      </h1>
      <p className="text-sm sm:text-base text-slate-500 text-center max-w-md mb-2">
        To enable a login screen, please configure a{" "}
        <span className="font-semibold text-[#212430]">redirect URL</span> in
        your organization settings on the Rutter dashboard.
      </p>
    </div>
  );
};

const OtpLogin = ({
  handleCompleteCancel,
  handleCompleteSubmit,
  platform,
}: DefaultLoginType) => {
  const { orgInfo, password, setPassword, isSubmitting } = useBankFeeds();

  return (
    <>
      <h2 className="text-lg mt-4">One-Time Password (OTP)</h2>
      <div className="mt-1 font-thin" style={{ fontWeight: 300 }}>
        {orgInfo.otpInstructions ??
          `Please enter the one-time password (OTP) provided to you by your financial institution. If you don't see it, check your financial institution's documentation for connecting to ${platform}`}
      </div>
      <div className="mt-2">
        <Input
          placeholder=""
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <Button
        className="        
      mt-[16px]
      flex 
      justify-center
      items-center 
      py-5
      rounded-md
      font-medium
      bg-[#fff] border-slate-300 
      hover:bg-[#F9FAFC] 
      hover:border-[#212430] hover:text-[#212430]
      border-1.5 
    "
        block
        onClick={handleCompleteCancel}
      >
        Cancel
      </Button>
      <Button
        className="
       flex 
        justify-center 
        items-center 
        py-5 mt-2
        rounded-md 
        text-white
        font-medium
        bg-[#212430] 
        hover:bg-[#020211] hover:text-[#fff] hover:border-[#020211]
        mb-[32px]
    "
        block
        disabled={!password}
        loading={isSubmitting}
        onClick={handleCompleteSubmit}
      >
        Submit
      </Button>
    </>
  );
};
